<template>
	<div class="modal-content-inner">
		<div class="text-center">
			<svg width="160" height="160" viewBox="0 0 160 160">
				<g class="fill-theme-color" fill-rule="nonzero">
					<path d="M116.571 75.395v4.571H43.43v-4.571z"/>
					<path d="M64.167 63.966h31.67l7.02 11.128-4.463 2.586-5.499-8.715h-25.79l-5.5 8.716-4.462-2.588z"/>
					<path d="M102.155 77.68l5.274.369-3.937 54.489H56.513l-3.942-54.489 5.274-.368 3.588 49.658h37.133z"/>
					<path d="M75.429 86.823v32h-4.572v-32zM89.143 86.823v32H84.57v-32zM81.636 45.714l.061-.948c.112-1.016.553-1.902 1.324-2.66l1.233-1.196c.964-.954 1.64-1.822 2.025-2.605a5.573 5.573 0 0 0 .578-2.495c0-1.939-.593-3.44-1.78-4.502-1.188-1.062-2.857-1.594-5.009-1.594-2.13 0-3.812.56-5.045 1.68-1.233 1.12-1.86 2.669-1.88 4.649h4.414c.02-.83.256-1.48.708-1.952.451-.471 1.053-.707 1.803-.707 1.583 0 2.375.876 2.375 2.628 0 .58-.152 1.132-.457 1.656-.304.523-.915 1.202-1.834 2.037-.918.834-1.55 1.681-1.895 2.542-.345.86-.517 2.016-.517 3.467M80 52.571c.687 0 1.24-.214 1.658-.642.418-.428.628-.971.628-1.628 0-.668-.214-1.218-.642-1.651-.428-.433-.976-.65-1.644-.65-.668 0-1.216.217-1.644.65-.428.433-.642.983-.642 1.65 0 .658.21 1.2.628 1.629.419.428.971.642 1.658.642zM106.78 45.714l.06-.948c.112-1.016.553-1.902 1.324-2.66l1.233-1.196c.964-.954 1.639-1.822 2.025-2.605A5.573 5.573 0 0 0 112 35.81c0-1.939-.594-3.44-1.78-4.502-1.188-1.062-2.857-1.594-5.009-1.594-2.13 0-3.813.56-5.045 1.68-1.233 1.12-1.86 2.669-1.88 4.649h4.414c.02-.83.256-1.48.708-1.952.451-.471 1.052-.707 1.803-.707 1.583 0 2.375.876 2.375 2.628 0 .58-.152 1.132-.457 1.656-.304.523-.916 1.202-1.834 2.037-.918.834-1.55 1.681-1.895 2.542-.345.86-.517 2.016-.517 3.467m2.26 6.857c.687 0 1.24-.214 1.658-.642.418-.428.628-.971.628-1.628 0-.668-.214-1.218-.642-1.651-.428-.433-.976-.65-1.644-.65-.668 0-1.216.217-1.644.65-.428.433-.642.983-.642 1.65 0 .658.21 1.2.628 1.629.419.428.971.642 1.658.642zM56.493 45.714l.061-.948c.112-1.016.553-1.902 1.325-2.66l1.232-1.196c.964-.954 1.64-1.822 2.025-2.605a5.573 5.573 0 0 0 .578-2.495c0-1.939-.593-3.44-1.78-4.502-1.188-1.062-2.857-1.594-5.008-1.594-2.131 0-3.813.56-5.046 1.68-1.233 1.12-1.86 2.669-1.88 4.649h4.414c.02-.83.256-1.48.708-1.952.451-.471 1.053-.707 1.804-.707 1.583 0 2.374.876 2.374 2.628 0 .58-.152 1.132-.456 1.656-.305.523-.916 1.202-1.835 2.037-.918.834-1.55 1.681-1.895 2.542-.345.86-.517 2.016-.517 3.467m2.26 6.857c.687 0 1.24-.214 1.658-.642.419-.428.628-.971.628-1.628 0-.668-.214-1.218-.642-1.651-.428-.433-.976-.65-1.644-.65-.668 0-1.216.217-1.644.65-.428.433-.642.983-.642 1.65 0 .658.21 1.2.628 1.629.419.428.971.642 1.658.642z"/>
				</g>
			</svg>
			<div class="mb-3">
				<div class="modal-ask-title">{{'deviceon.device.message.removeWarning' | translate}}</div>
				<!-- <div class="modal-ask-text">{{'deviceon.device.message.removeContent' | translate}}</div> -->
			</div>
		</div>
		<div class="row mb-3" >
			<div class="col-6">
				<button
					type="button"
					:class="'btn btn-primary'"
					@click="deleteObject"
				>{{ 'modal.delete' | translate }}</button>
			</div>
			<div class="col-6">
				<button
					type="button"
					:class="'btn btn-secondary'"
					@click="cancel"
				>{{ 'modal.cancel' | translate }}</button>
			</div>
		</div>
	</div>
</template>

<script>

export default {
  name: 'deleteModal',
  methods: {
    deleteObject () {
      this.$emit('delete')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
